import styled, { css } from 'styled-components';
import { Input } from 'antd';

const vars = {
  shade1: 'grey',
  darkGrey: 'black',
  lightGrey: 'white',
  placeholder: 'Enter a address',
};

const defaultBorderRadius = '10px';

const pxToRem = '1.5rem';

export const inputCss = css`
  width: 100%;
  min-width: 200px;
  height: 56px;
  padding: 15px 10px;
  border: 1px solid ${vars.shade1};
  border-radius: ${defaultBorderRadius};
  font-size: ${pxToRem};
  color: ${vars.darkGrey};
  background-color: ${vars.lightGrey};
  &::placeholder {
    color: ${vars.placeholder};
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(16, 130, 234, 0.2);
  }
  &:-webkit-autofill {
    &,
    &:hover,
    &:focus,
    &:active {
      /* https://stackoverflow.com/a/29350537/2099524 */
      transition: background-color 5000s ease-in-out 0s;
    }
  }
`;

export const InputStyled = styled(Input)`
  height: 56px;
  border-radius: ${defaultBorderRadius};
  background-color: ${vars.lightGrey};
  &.ant-input {
    ${inputCss}
    &.-floating {
      padding: 30px 10px 12px;
    }
  }
  .ant-input /* with prefix/suffix */ {
    ${inputCss}
    height: auto;
    &.-floating {
      padding: 30px 10px 12px;
    }
  }
  &.ant-input-affix-wrapper /* with prefix/suffix */ {
    background-color: ${vars.lightGrey} !important;
    .ant-input:not(.ant-input-disabled) {
      &:hover {
        border-color: ${vars.shade1};
      }
    }
    .anticon {
      font-size: ${pxToRem};
      color: ${vars.darkGrey};
    }
  }
`;

export const TextAreaStyled = styled(Input.TextArea)`
  ${inputCss}
  &.ant-input {
    display: block;
    height: 150px;
    background-color: ${vars.lightGrey} !important;
  }
`;

export const FloatingLabel = styled.label`
  opacity: 0;
  z-index: 10;
  position: absolute;
  flex-basis: 100%;
  transform: translateY(0);
  pointer-events: none;

  &.-show {
    color: grey;
    font-size: ${pxToRem};
    line-height: ${pxToRem};
    display: block;
    opacity: 1;
    padding-top: 5px;
    padding-left: 10px;
    transform: translateY(3px);
    transition-duration: 0.5s;
    transition-property: opacity, transform;
  }
`;
